import {JavascriptFunctionName} from "../../../controller/externalInterface/JavascriptFunctionName";
import {AbstractJavascriptFunctionCallVO} from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallVO";

export class JavascriptCallSetSessionParametersVO implements AbstractJavascriptFunctionCallVO {
    public functionName = JavascriptFunctionName.SET_SESSION_PARAMETERS;
    public parameters;

    /**
     * Defines parameters needed for calling "setSessionParameters" javascript function.
     *
     * Full documentation for javascript/flash interface see:
     * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AtXFx56d9X1adDlYcUtZc3JVdThMQ0NES0pUYlFqMHc#gid=0
     */
    constructor(gameId: number, networkId: number, instanceId: number, playerId: number, accountId: string, ggsLanguageCode: string, ggsCountryCode: string, pln: string, displayName: string, versionClient: string, versionServer: string) {


        let sessionParameters: any = {};
        sessionParameters.gameId = gameId;
        sessionParameters.networkId = networkId;
        sessionParameters.instanceId = instanceId;
        sessionParameters.playerId = playerId;
        sessionParameters.accountId = accountId;
        sessionParameters.languageCode = ggsLanguageCode;
        sessionParameters.countryCode = ggsCountryCode;
        sessionParameters.pln = pln;
        sessionParameters.displayName = displayName;
        sessionParameters.versionClient = versionClient;
        sessionParameters.versionServer = versionServer;

        this.parameters = [sessionParameters];
    }
}
